import * as React from 'react';
import { Slideshow } from '../../../../interfaces/models';
import { Entity } from '../EntityResults/Result';
import Table from '../../Table';
import { TrashIcon } from '@heroicons/react/24/outline';

interface RelatedSlideshowsProps {
  slideshows: Slideshow[];
  onRemove: (entity: Entity) => void;
}

const RelatedSlideshows: React.FC<RelatedSlideshowsProps> = ({
  slideshows,
  onRemove,
}) => {
  const onRemoveSlideshow = (
    e: React.MouseEvent<HTMLButtonElement>,
    slideshow: Slideshow
  ): void => {
    e.preventDefault();
    onRemove(slideshow);
  };

  if (slideshows.length > 0) {
    return (
      <>
        <h3 className="medium-title mb-2 mt-3">Slideshows</h3>
        <Table headings={['ID', 'Name', 'Actions']}>
          {slideshows.map((slideshow) => (
            <tr
              key={`${slideshow.__typename}-${slideshow.id}`}
              className="hover:bg-gray-50"
            >
              <td className="w-1 px-6 py-2 whitespace-nowrap">
                {slideshow.id}
              </td>
              <td className="px-6 py-2 whitespace-nowrap">{slideshow.name}</td>
              <td className="w-2 px-6 py-2 whitespace-nowrap">
                <button
                  className="btn py-1"
                  onClick={(e) => onRemoveSlideshow(e, slideshow)}
                >
                  <TrashIcon className="h-5 w-5" />
                </button>
              </td>
            </tr>
          ))}
        </Table>
      </>
    );
  } else {
    return null;
  }
};

export default RelatedSlideshows;
